<template>
  <v-content>
    <v-card>
      <v-layout class="text-field-add-account">
        <v-flex xs10 mt-8>
          <v-form ref="form" v-if="form.id === null" v-model="valid" lazy-validation>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ชื่อ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.fname"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="fnameRules"
                  label="ชื่อ"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                นามสกุล :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.lname"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="lnameRules"
                  label="นามสกุล"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                อีเมล :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.email"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="emailRules"
                  label="อีเมล"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หมายเลขโทรศัพท์ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.number"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="numberRules"
                  label="หมายเลขโทรศัพท์"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หน่วยงาน :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.department"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :items="organitzation"
                  item-text="organization_name"
                  item-value="organization_id"
                  :value-comparator="findMatchingOrganization"
                  :rules="[v => !!v || 'Item is required']"
                  label="หน่วยงาน :"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                รหัสผู้ใช้งาน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.userNo"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="userNoRules"
                  label="รหัสผู้ใช้งาน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                รหัสผ่าน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="password"
                  v-model="form.password"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="passwordRules"
                  label="รหัสผ่าน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ยืนยันรหัสผ่าน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="password"
                  v-model="form.confirm_Password"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="ConfirmPasswordRules"
                  label="ยืนยันรหัสผ่าน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 style="text-align: right;">
                สถานะบัญชีผู้ใช้งาน :
              </v-flex>
              <v-flex xs6 mb-6 pl-4>
                <v-radio-group class="ma-0 pa-0"
                               :mandatory="false"
                               v-model="form.checkbox"
                               :rules="[v => !!v || 'You must agree to continue!']"
                               required>
                  <v-row>
                    <v-radio color="#527281" label="ใช้งาน" value="1" class="pa-0 ma-0"></v-radio>
                    <v-radio color="#527281" label="ยกเลิก" value="0" class="ml-4"></v-radio>
                  </v-row>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>

          <v-form ref="form" v-else v-model="valid" lazy-validation>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ชื่อ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.fname"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="fnameRules"
                  label="ชื่อ"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                นามสกุล :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.lname"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="lnameRules"
                  label="นามสกุล"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                อีเมล :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.email"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="emailRules"
                  label="อีเมล"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หมายเลขโทรศัพท์ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.number"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="numberRules"
                  label="หมายเลขโทรศัพท์"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หน่วยงาน :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.department"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :items="organitzation"
                  item-text="organization_name"
                  item-value="organization_id"
                  :value-comparator="findMatchingOrganization"
                  :rules="[v => !!v || 'Item is required']"
                  label="หน่วยงาน :"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                รหัสผู้ใช้งาน :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.userNo"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="userNoRules"
                  label="รหัสผู้ใช้งาน"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

<!--            <v-layout justify-center>-->
<!--              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">-->
<!--                รหัสผ่าน :-->
<!--              </v-flex>-->
<!--              <v-flex xs6>-->
<!--                <v-text-field-->
<!--                  type="password"-->
<!--                  v-model="form.password"-->
<!--                  background-color="#E5E5E5"-->
<!--                  solo-->
<!--                  flat-->
<!--                  :rules="passwordRules"-->
<!--                  label="รหัสผ่าน"-->
<!--                  required-->
<!--                ></v-text-field>-->
<!--              </v-flex>-->
<!--            </v-layout>-->

<!--            <v-layout justify-center>-->
<!--              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">-->
<!--                ยืนยันรหัสผ่าน :-->
<!--              </v-flex>-->
<!--              <v-flex xs6>-->
<!--                <v-text-field-->
<!--                  type="password"-->
<!--                  v-model="form.confirm_Password"-->
<!--                  background-color="#E5E5E5"-->
<!--                  solo-->
<!--                  flat-->
<!--                  :rules="ConfirmPasswordRules"-->
<!--                  label="ยืนยันรหัสผ่าน"-->
<!--                  required-->
<!--                ></v-text-field>-->
<!--              </v-flex>-->
<!--            </v-layout>-->

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 style="text-align: right;">
                สถานะบัญชีผู้ใช้งาน :
              </v-flex>
              <v-flex xs6 mb-6 pl-4>
                <v-radio-group class="ma-0 pa-0"
                               :mandatory="false"
                               v-model="form.checkbox"
                               :rules="[v => !!v || 'You must agree to continue!']"
                               required>
                  <v-row>
                    <v-radio color="#527281" label="ใช้งาน" value="1" class="pa-0 ma-0"></v-radio>
                    <v-radio color="#527281" label="ยกเลิก" value="0" class="ml-4"></v-radio>
                  </v-row>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Button -->
    <v-layout>
      <v-flex mt-8 pr-12 style="text-align: right;">

        <v-btn
          color="#BDBDBD"
          class="mr-4"
          @click="$router.push('/manage-user-accounts').catch(err => {})"
        >
          ย้อนกลับ
        </v-btn>

        <v-btn v-if="isEdit==true"
               color="#D97C57"
               class="mr-4"
               @click="deleteAccount()"
        >
          <span style="color: white;">ลบบัญชี</span>
        </v-btn>

        <v-btn v-if="isEdit==true"
               :disabled="!valid"
               color="#527281"
               class="mr-4"
               @click="editAccount()"
        >
          <span style="color: white;">ยืนยันการแก้ไขบัญชีผู้ใช้</span>
        </v-btn>

        <v-btn v-if="isAdd==true"
               :disabled="!valid"
               color="#527281"
               class="mr-4"
               @click="saveAccount()"
        >
          <span style="color: white;">ยืนยันการเพิ่มบัญชีผู้ใช้</span>
        </v-btn>
      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
    import validate from "../utils/validate";
    import Service from '../service';

    export default {
        created() {
            this.userId = this.$route.params.id;
            if (this.$route.params.id) {
                this.getUser();
            }
            this.showOrganization();
        },
        name: "FormManageAccount",
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            isAdd: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            userId: '',
            name: '',
            select: null,
            noAcc: '',
            valid: true,
            organitzation: [],
            form: {
                id: null,
                fname: "",
                lname: "",
                email: "",
                number: "",
                department: "",
                userNo: "",
                password: null,
                confirm_Password: null,
                checkbox: "",
            },
            fnameRules: [
                v => validate.required(v, "fname"),
            ],
            lnameRules: [
                v => validate.required(v, "lname"),
            ],
            emailRules: [
                v => validate.validEmail(v, "email"),
                v => validate.required(v, "email"),
            ],
            numberRules: [
                v => validate.onlyNumber(v, "number"),
                v => validate.required(v, "number"),
            ],
            userNoRules: [
                v => validate.required(v, "userNo"),
            ],
            passwordRules: [
                v => validate.required(v, "password"),
            ],
            ConfirmPasswordRules: [
                v => validate.required(v, "confirm_Password"),
                // v => validate.confirmPassword(v, "confirm_Password"),
            ],
        }),
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },

            // Get User Data when edit
            getUser() {
                Service.User.getUser(this.userId).then(data => {
                    let user = data;
                    this.form.id = user.id;
                    this.form.fname = user.firstname;
                    this.form.lname = user.lastname;
                    this.form.email = user.email;
                    this.form.number = user.tel;
                    this.form.department = user.organization_id;
                    this.form.userNo = user.username;
                    this.form.password = user.password;
                    this.form.confirm_Password = user.password;
                    this.form.checkbox = user.status;

                })
            },

            showOrganization() {
                Service.Organization.showOrganization().then(res => {
                    res.data.forEach(dataOrganitzation => {
                        this.organitzation.push({
                            organization_id: `${dataOrganitzation.id}`,
                            organization_name: `${dataOrganitzation.name}`
                        });
                    })
                })
            },
            findMatchingOrganization(a,b) {
                return a==b;
            },

            // Save Data when add User
            async saveAccount() {
                if (this.$refs.form.validate() == false) {
                    console.log('Error');
                } else {
                    confirm('Do you want to Save Account');
                    let result = await Service.User.saveAccount({
                        firstname: this.form.fname,
                        lastname: this.form.lname,
                        email: this.form.email,
                        tel: this.form.number,
                        organization_id: this.form.department,
                        username: this.form.userNo,
                        password: this.form.password,
                        c_password: this.form.confirm_Password,
                        checkbox: this.form.checkbox,
                    })
                    if (result) {
                        alert('Save Success')
                        // this.$router.push('/manage-user-accounts')
                    } else {
                        alert('Save Error')
                    }

                }
            },

            // Save Data when edit User
            editAccount() {
                if (this.$refs.form.validate() == false) {
                    console.log('Error');
                } else {
                    confirm('Do you want to Edit Account ID : ' + this.$route.params.id);

                    let result = Service.User.editAccount({
                        id: this.userId,
                        firstname: this.form.fname,
                        lastname: this.form.lname,
                        email: this.form.email,
                        tel: this.form.number,
                        organization_id: this.form.department,
                        username: this.form.userNo,
                        // password: this.form.password,
                        // confirm_Password: this.form.confirm_Password,
                        checkbox: this.form.checkbox,
                    })
                    if (result) {
                        alert('Edit Success')
                        // this.$router.push('/manage-user-accounts')
                    }else {
                        alert('Edit Error...');
                    }

                }
            },

            // Delete Data User
            async deleteAccount() {
                confirm('Do you want to delete Account ID : ' + this.$route.params.id);

                let result = await Service.User.deleteAccount({
                    id: this.userId,
                })

                if (result) {
                    alert("Delete Success")
                    this.$router.push('/manage-user-accounts').catch(err => {})
                }else {
                    alert("Delete Failed")
                }
            }
        }
    }
</script>

<style lang="scss">
  .text-field-add-account {
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: auto;
      border-radius: 20px;
    }

    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: #527281;
    }

    .theme--light.v-select .v-select__selections {
      color: #527281;
    }
  }
</style>
